import React from 'react'
import flatMap from 'lodash/flatMap'

import { Assets } from '@containers/Assets'

import {
  totalContributions,
  totalCapital
} from '@utils/assets'

import { ParticipantFilter } from './ParticipantFilter'

export const JointAssets = ({ participantsQueries, config }) => {
  const [selectedParticipantId, setSelectedParticipantId] = React.useState('both')
  const selectedParticipantQuery = participantsQueries.find((participantQuery) => participantQuery.participant.id === selectedParticipantId)

  const assets = selectedParticipantQuery
    ? selectedParticipantQuery.assets.data
    : flatMap(participantsQueries, (participantQuery) => participantQuery.assets.data)

  return (
    <>
      <Assets
        filter={ (view) => (
          <ParticipantFilter
            showBoth
            view={view}
            filteredItemsName={'assets'}
            participantsQueries={participantsQueries}
            selectedParticipantId={selectedParticipantId}
            setSelectedParticipantId={setSelectedParticipantId}
          />
        )}
        scenario={{
          id: selectedParticipantQuery?.scenario.data.baseScenario.id,
          planType: selectedParticipantQuery?.scenario.data.baseScenario.planType,
          retirementAge: selectedParticipantQuery?.scenario.data.baseScenario.retirementAge,
          isRetired: selectedParticipantQuery?.scenario.data.baseScenario.isRetired
        }}
        tenant={config.tenant}
        assets={assets}
        totalContributions={totalContributions(assets, config.supportedCurrencies)}
        totalCapital={totalCapital(assets, config.supportedCurrencies)}
        crudActions={selectedParticipantQuery?.assets.actions}
        // onCreateNewScenario={onCreateNewScenario}

        riskProfile={selectedParticipantQuery?.riskProfile.data.baseRiskProfile}
        assumptions={selectedParticipantQuery?.scenario.data.baseScenario.assumptions}
        assetView={'grid'}
        serviceProviders={config.serviceProviders}
        supportedCurrencies={config.supportedCurrencies}

        featureToggles={config.featureToggles}
        featureConfig={config.featureConfig}
        userDetails={config.userDetails}
      />
    </>
  )
}
